<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emArchScrapProcessAspResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" checkboxColumnDisabled editDisable
                                      with-custom-row-actions-first-column>
                                <template #left-header>
                                    <b-button-group>
                                        <em-button type="process"
                                                   id="scrapSelect"
                                                   class="btn btn-outline-primary btn-sm"
                                                   :busy="scrapLoading"
                                                   customLabel="发起报废">
                                        </em-button>
                                        <b-popover target="scrapSelect" triggers="hover" placement="right">
                                            <template v-for="item of scrapTypes">
                                                <b-button variant="light" :key="item.value" class="mr-1"
                                                          @click="typeClicked(item)">
                                                    {{ item.label }}
                                                </b-button>
                                            </template>
                                        </b-popover>
                                    </b-button-group>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="task"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector" disable-store checkEnable
                                  @checkFinish="whenCheckFinish"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2022-05-10 16:24:15
import emWorkflowListMixin from "@/mixin/em/workflow/list";

export default {
    name: "emArchScrapProcessAspWorkflowListView",
    mixins: [emWorkflowListMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    data() {
        return {
            scrapTypes: [
                {value: 1, label: '设备/吊索具', code: 'ARCHIVE'},
                {value: 2, label: '工装', code: 'TOOLS'},
                {value: 3, label: '工具刀具', code: 'TOOLS_CUTTERS'},
            ],
            scrapLoading: false,
            selectedType: {}
        }
    },
    methods: {
        typeClicked(item) {
            const ENTITY_NAME = {
                1: 'emArchBasicData',
                2: 'sithMesPrdToolsInfo',
                3: 'emArchTool',
            }
            this.selectedType = item;
            this.openEntitySelector(ENTITY_NAME[item.value])
        },
        openEntitySelector(entityName) {
            this.$refs.emModalEntitySelector.setCustomVuexConfig(entityName, undefined, 30);
            this.$refs.emModalEntitySelector.onlyShowModal();
        },
        whenCheckFinish(ids) {
            if (ids) {
                this.scrapLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_EM_ARCHIVE_URL}/emArchScrapProcessAsp/initiate?type=${this.selectedType.code}&ids=${ids}`,
                    data: {},
                }).then(() => {
                    this.$message.success("发起成功");
                    this.$refs.emListFilter.doQuery();
                })
                    .finally(() => this.scrapLoading = false);
            }
        },
    },
};
</script>